import { Loadable } from '../../models';
import { AccountDetail } from '../../models/account';
import { Company } from '../../models/company';
import { SimSubmission } from '../transfer/input/SimSubmission';

/** The number of seconds the application will wait before refreshing Spend Caps from the server. */
export const SpendCapFileCacheTimeout = 3600;

/** The number of seconds the application will wait before refreshing the selected submission from the server. */
export const SimSubmissionCacheTimeout = 3600;

/**
 * Interface which encapsulates the currently selected filter settings.
 */
export interface FilterSettingsState {
  account: Loadable<AccountDetail>;
  company: Loadable<Company>;
  simSubmission: Loadable<SimSubmission>;
  isLoading: boolean;
}

/**
 * Interface which encapsulates the user's currently saved default filter settings.
 */
export interface UserDefaultFilter {
  account?: AccountDetail;
  company?: Company;
}

export const getDefaultFilterAccount = () => {
  return {
    isLoading: false,
    id: 0,
    isAtlasAccount: false,
  };
};

export const getDefaultFilterCompany = () => {
  return {
    isLoading: false,
    id: 0,
    name: '',
  };
};

/**
 * The default filter settings
 * These are just to get us up and running - the server may have its own defaults.
 */
export const getDefaultFilterSettingsState = (): FilterSettingsState => {
  return {
    isLoading: false,
    account: getDefaultFilterAccount(),
    company: getDefaultFilterCompany(),
    simSubmission: getDefaultSimSubmissionState(),
  };
};

/**
 * Gets default settings for a SIM submission
 */
export const getDefaultSimSubmissionState = (): Loadable<SimSubmission> => {
  return {
    isLoading: false,
    ticketNumber: '',
    description: '',
    actionOn: new Date(),
    type: '',
    createdOn: new Date(),
    createdBy: '',
    status: 'pending',
    commands: [],
  };
};
